// extracted by mini-css-extract-plugin
export default {"menu":"_header_menu__ycA0J","menuItem":"_header_menuItem__yq2te","getInTouchBtn":"_header_getInTouchBtn__7ejaN"};